import React, { useEffect, useState } from 'react'

import axiosInstance, { API_BASE } from '../apiconfig'
import { FaEdit, FaTrash } from 'react-icons/fa'
import { DataGrid } from "@mui/x-data-grid";
import { GridActionsCellItem } from '@mui/x-data-grid';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const API = `${API_BASE}/api/farmers`

export default function Farmers() {
  const [farmers, setFarmers] = useState([])
  const [form, setForm] = useState({ firstName: '', lastName: '', fatherName: '', mobile: '', code: '', interestRate: 0, interestMonth: '', openingBalance: 0 })
  const [editing, setEditing] = useState(null)
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({});

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50
  });

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "code", headerName: "Code", width: 80 },
    { field: "firstName", headerName: "First Name", flex: 1, minWidth: 150 },
    { field: "lastName", headerName: "Last Name", flex: 1, minWidth: 50 },
    { field: "fatherName", headerName: "FatherName", flex: 1 },
    { field: "mobile", headerName: "Mobile", width: 100 },
    { field: "interestRate", headerName: "Int. Rate", width: 100 },
    { field: "interestMonth", headerName: "Int. Month", width: 100 },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 120,
      getActions: (params) => [
        <GridActionsCellItem
          key={`edit-${params.row.id}`}
          icon={<EditIcon />}
          label="Edit"
          onClick={() => startEdit(params.row)}
        />,
        <GridActionsCellItem
          key={`delete-${params.row.id}`}
          icon={<DeleteIcon />}
          label="Delete"
          onClick={() => del(params.row.id)}
          showInMenu={false}
        />
      ]

    }
  ];

  useEffect(() => {
    fetchList();
  }, [paginationModel]);

  // const fetchList = async () => {
  //   const res = await axiosInstance.get(API); setFarmers(res.data)
  // }

  const fetchList = async () => {
    setLoading(true);

    const res = await axiosInstance.get(API, {
      params: {
        page: paginationModel.page + 1, // convert to 1-based
        pageSize: paginationModel.pageSize
      }
    });

    setRows(res?.data?.data ?? []);
    setTotal(res?.data?.totalCount ?? []);
    setLoading(false);
  };

  const submit = async (e) => {
    e.preventDefault()

    const newErrors = {};

    if (!form.firstName?.trim()) newErrors.firstName = "First Name is required";
    if (!form.code?.trim()) newErrors.code = "Farmer code is required";
    // Stop submit if errors exist
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});


    if (editing) {

      await axiosInstance.put(`${API}/${editing}`, form)
      setEditing(null)
    } else {
      await axiosInstance.post(API, form)
    }
    setForm({ firstName: '', lastName: '', fatherName: '', mobile: '', code: '', interestRate: 0, interestMonth: '', openingBalance: 0 })
    fetchList()
  }

  const del = async (id) => { if (!confirm('You want to Delete?')) return; await axiosInstance.delete(`${API}/${id}`); fetchList() }
  const startEdit = (f) => { setEditing(f.id); setOpen(true); setForm({ firstName: f.firstName || '', lastName: f.lastName || '', fatherName: f.fatherName || '', mobile: f.mobile || '', code: f.code || '', interestRate: f.interestRate || 0, openingBalance: f.openingBalance || 0, interestMonth: f.interestMonth || '' }) }

  return (
    <div className="">
      <div className="panel">
        <div className="panel-header" onClick={() => setOpen(!open)}>
          <h3>Add / Edit Farmer</h3>
          <span className={open ? "rotate" : ""}>▼</span>
        </div>

        <div className={`collapse ${open ? "open" : ""}`}>
          <div className="panel-body">
            <form onSubmit={submit} className="form">
              <label>First Name*<input value={form.firstName} onChange={e => setForm({ ...form, firstName: e.target.value })} />
                {errors.firstName && <small className="error">{errors.firstName}</small>}</label>

              <label>Last Name<input value={form.lastName} onChange={e => setForm({ ...form, lastName: e.target.value })} /></label>
              <label>Father Name<input value={form.fatherName} onChange={e => setForm({ ...form, fatherName: e.target.value })} /></label>
              <label>Mobile No<input type="number" value={form.mobile} maxLength={10} onChange={e => setForm({ ...form, mobile: e.target.value })} /></label>
              <label>Code<input value={form.code} onChange={e => setForm({ ...form, code: e.target.value })} />
                {errors.code && <small className="error">{errors.code}</small>} </label>
              <label>Interest Rate<input type="number" value={form.interestRate} onChange={e => setForm({ ...form, interestRate: parseFloat(e.target.value) || 0 })} /></label>
              <label>Interest Month<input type="number" value={form.interestMonth} onChange={e => setForm({ ...form, interestMonth: e.target.value })} /></label>
              {/* <label>Opening Balance<input value={form.openingBalance} onChange={e => setForm({ ...form, openingBalance: parseFloat(e.target.value) || 0 })} /></label> */}
              <div className="actions"><button type="submit">{editing ? 'Update' : 'Create'}</button>
                {editing && <button type="button" onClick={() => { setEditing(null); setForm({ firstName: '', lastName: '', fatherName: '', mobile: '', code: '', interestRate: 0, interestMonth: '', OpeningBalance: 0 }) }}>Cancel</button>}
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* <table className="data">
        <thead><tr><th>#</th><th>Name</th><th>Mobile</th><th>Code</th><th>OpeningBalance</th><th>Actions</th></tr></thead>
        
      </table> */}

      <div className="data">
        <DataGrid
          rows={rows}
          columns={columns}
          rowCount={total}
          loading={loading}
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10, 20, 50, 100]}
          columnVisibilityModel={{ id: false }}

        />
      </div>
    </div>
  )
}
